<nav class="sidebar sidebar-offcanvas" id="sidebar">
    <ul class="nav">
        <li class="nav-item" id="dashboard-c">
            <a class="nav-link " (click)="onClickListMenu()" [routerLink]="['/committee/dashboard']">
                <span class="menu-title">หน้าหลัก</span>
                <i class="mdi mdi-home menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="project-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/project-support']">
                <span class="menu-title">ผลการสนับสนุนโครงการจัดรูปที่ดิน</span>
                <i class="mdi mdi-chart-areaspline menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="project-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/result']">
                <span class="menu-title">ผลการดำเนินทุนหมุนเวียน</span>
                <i class="mdi mdi-chart-areaspline menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="financial-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/financial-statements']">
                <span class="menu-title">รายงานงบการเงิน</span>
                <i class="mdi mdi-file-document menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="financial-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/auditbyInternal']">
                <span class="menu-title">รายงานการตรวจสอบโดยกลุ่มการตรวจสอบภายใน</span>
                <i class="mdi mdi-file-document menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="performance-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/performance-appraisal']">
                <span class="menu-title">การประเมินผลการดำเนินงาน</span>
                <i class="mdi mdi-chart-bar menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="personnel-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/personnel']">
                <span class="menu-title">บันทึกการลาของบุคลากร</span>
                <i class="mdi mdi-account-multiple menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" id="meeting-c">
            <a class="nav-link" (click)="onClickListMenu()" [routerLink]="['/committee/meeting-minutes']">
                <span class="menu-title">รายงานการประชุม</span>
                <i class="mdi mdi-book-multiple menu-icon"></i>
            </a>
        </li>
    </ul>
</nav>